<template>
  <v-container
    id="cobraSummary"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <div>
      <div class="oe-summary-title">
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          :color="approvals.color"
          @click="displaySection = !displaySection"
        >
          <v-icon
            v-show="!displaySection"
            dark
          >
            mdi-arrow-expand-vertical
          </v-icon>
          <v-icon
            v-show="displaySection"
            dark
          >
            mdi-arrow-expand-horizontal
          </v-icon>
        </v-btn>
        Cobra Summary
      </div>
      <v-fab-transition>
        <note
          v-show="displaySection"
          :open-enrollment="openEnrollment"
          :section="sections.cobra"
          summary="true"
        />
      </v-fab-transition>
      <div v-if="!loading && cobras && cobras.length">
        <div
          v-for="(cobra, i) in cobras"
          :key="i"
        >
          <v-fab-transition>
            <div
              v-show="displaySection"
              class="oe-summary-subsection mt-6"
            >
              <div class="text-center display-1">
                {{ cobra.cobra }}
              </div>
              <v-row>
                <v-col cols="6">
                  <base-display-value
                    v-model="cobra.product"
                    label="Product"
                  />
                </v-col>
                <v-col cols="6">
                  <base-display-value
                    v-model="cobra.carrier"
                    label="Carrier"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <base-display-value
                    v-model="cobra.carrierAdministering"
                    label="Administering Carrier"
                  />
                </v-col>
                <v-col cols="6">
                  <base-display-value
                    v-model="cobra.cobraEligible"
                    label="COBRA Eligible"
                    data-type="boolean"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <base-display-value
                    v-model="cobra.sendFilesToProductCarrierEDI"
                    label="Send Files to Product Carrier (EDI)"
                    data-type="boolean"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <base-display-value
                    v-model="cobra.sendInitialNoticesTermsToCobraAdmin"
                    label="Send Initial Notices and Terms to Cobra Admin"
                    data-type="boolean"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <base-display-value
                    v-model="cobra.ratesDiffThanActive"
                    label="Rates different than active"
                    data-type="boolean"
                  />
                </v-col>
              </v-row>
            </div>
          </v-fab-transition>
        </div>
      </div>
      <v-fab-transition>
        <v-alert
          v-show="displaySection && (!loading && (!cobras || !cobras.length))"
          type="info"
        >
          No cobra details found
        </v-alert>
      </v-fab-transition>
      <v-fab-transition>
        <approval
          v-show="displaySection"
          :approvals="approvals"
          :allow-change="!print"
          @approval:changed="$emit('approval:changed')"
        />
      </v-fab-transition>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'CobraSummary',

    components: {
      Note: () => import('./Note'),
      Approval: () => import('./Approval'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      openEnrollment: {
        type: Object,
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      displaySection: true,

      loadingCobra: false,

      errorMessage: null,
      displayError: false,
      formErrors: {},

      cobras: null,

      cobraResource: new TroodyApi('oeCobra/'),
      approvals: null,
    }),

    computed: {
      loading () {
        return (this.loadingCobra)
      },

      sections () {
        return Approvals.sections
      },
    },

    watch: {
      expanded (val) {
        this.displaySection = val
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadCobra()
        this.approvals = new Approvals(this.openEnrollment.id, Approvals.sections.cobra.id)
        this.displaySection = this.expanded
      },

      loadCobra () {
        this.loadingCobra = true
        this.cobraResource.query({ openEnrollmentId: this.openEnrollment.id })
          .then(data => {
            console.log('cobra')
            console.log(data)
            this.loadingCobra = false
            this.cobras = data
          })
          .catch((error) => {
            this.loadingCobra = false
            this.cobras = null
            this.showError(error, 'Failed to load COBRA details!')
          })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>
